import { IController } from 'angular';
import { inject, injectable } from '../../../shared/utils/inject/inject';
import { IEventsService } from '../../services/eventsService/eventsService.factory';

/* @ngInject */
export function MenuBarController(
  eventsService: IEventsService,
  wixBinding,
  socialService,
) {
  // tslint:disable-next-line:no-invalid-this
  const vm = this;
  vm.local = eventsService.local;
  vm.settings = wixBinding.getSettings();
  vm.allEvents = allEvents;
  vm.localEvents = localEvents;
  vm.urls = socialService.urls;
  vm.goFacebook = goFacebook;
  vm.goTwitter = goTwitter;

  function goFacebook() {
    window.open(vm.urls.facebook, '', 'height=500,width=800');
  }

  function goTwitter() {
    window.open(vm.urls.twitter, '', 'height=400,width=800');
  }

  function allEvents() {
    eventsService.allEvents();
  }

  function localEvents() {
    eventsService.getLocalEvents();
  }
}
